import ReactDOM from "react-dom";
import "../index.css";
import * as serviceWorker from "../serviceWorker";

import React, { Component } from "react";
import Amplify, { Auth, Storage } from "aws-amplify";
import logo from "../logo.svg";
import "../App.css";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import AlertDialog from "../AlertDialog";
import Utils from "../Utils";
import PublicStorageManager from "../PublicProject/PublicStorageManager";
import ViewProjects from "../UserProject/NiceViewProjects";
import AddProject from "../UserProject/AddProject";
import { FileInput, AdornedButton } from "../UserProject/AddProject";
import Fade from "@material-ui/core/Fade";
import FormControl from "@material-ui/core/FormControl";
import GoogleMapsWithControls from "../UserProject/GoogleMapsWithControls";
import { AWS_CONFIG } from "../constants";

import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import { MUI_STYLES } from "../constants";
const styles = MUI_STYLES;

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

Amplify.configure(AWS_CONFIG);

class PublicUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSuccess: false,
      agreeTerms: false,
      projectName: "",
      description: "",
      email: "",
      lat: 30,
      lng: 0,
      rot: 0,
      validations: this.initValidations(),
      file: {},
      invalid: true,
      submitButton: "Send"
    };
    this.fileInput = React.createRef();
    this.markers = [];
    this.interacted = {};
    this.required = ["projectName", "file", "agreeTerms"];
  }

  componentDidMount() { }

  componentDidUpdate() {
    console.log(
      "add project state change:",
      this.state.invalid,
      this.state.validations
    );
  }

  setStateCallback = pData => {
    this.setState({
      changed: true,
      lat: pData.lat,
      lng: pData.lng,
      rot: pData.rot
    });
  };

  submit = async event => {
    event.preventDefault();

    this.setState({ loading: true });

    const file = this.fileInput.current.files[0];

    console.log("awsconfig.Storage");

    let userMan = new PublicStorageManager();

    await userMan.uploadNewModel(
      0,
      this.fileInput.current.files[0],
      this.state.projectName,
      file.name,
      this.state.lat || 30,
      this.state.lng || 0,
      this.state.rot || 0,
      this.state.description,
      this.state.email
    );
    this.setState({ loading: false });
    this.resetForm();
    this.handleModalSwitch(true);
    this.props.saveAddCallback();
  };

  handleFileUpload = e => {
    this.interacted.file = true;
    let validations = this.getValidations(this.state, this.interacted);
    let newState = Object.assign({}, this.state, validations);
    this.setState(newState);
    console.log(this.fileInput);
  };

  handleChange = name => event => {
    this.interacted[name] = true;
    let newState = {};

    Object.assign(newState, this.state, {
      [name]: event.target.value
    });

    let validations = this.getValidations(newState, this.interacted);
    Object.assign(newState, validations);
    this.setState(newState);
  };

  handleChecked = name => event => {
    this.interacted[name] = true;
    let newState = {};

    Object.assign(newState, this.state, {
      [name]: event.target.checked
    });
    let validations = this.getValidations(newState, this.interacted);
    Object.assign(newState, validations);
    this.setState(newState);
  };

  initValidations = () => {
    return {
      projectName: new Utils.Validation(),
      email: new Utils.Validation(),
      description: new Utils.Validation(),
      file: new Utils.Validation(),
      invalid: true,
      agreeTerms: new Utils.Validation()
    };
  };

  handleModalSwitch = value => {
    this.setState({ showSuccess: value });
  };

  getValidations = (state, interacted) => {
    let validations = {};
    Object.assign(validations, state.validations);

    if (interacted.file)
      validations.file = Utils.validateModel(this.fileInput);

    if (interacted.projectName) {
      if (!state.projectName || !state.projectName.length === 0) {
        validations.projectName = new Utils.Validation(
          "Project name missing",
          "error"
        );
      } else if (state.projectName.length > 30) {
        validations.projectName = new Utils.Validation(
          "Project name length exceeded",
          "error"
        );
      } else {
        validations.projectName = new Utils.Validation();
      }
    }
    if (interacted.email) {
      if (!state.email || !state.email.length === 0) {
        validations.email = new Utils.Validation("Email missing", "error");
      } else if (state.email.length > 35) {
        validations.email = new Utils.Validation(
          "Email length exceeded",
          "error"
        );
      } else if (!Utils.validateEmail(state.email)) {
        validations.email = new Utils.Validation(
          "Invalid email address",
          "error"
        );
      } else {
        validations.email = new Utils.Validation();
      }
    }
    if (interacted.description) {
      if (state.description.length > 400) {
        validations.description = new Utils.Validation(
          "Description length exceeded",
          "error"
        );
      } else {
        validations.description = new Utils.Validation();
      }
    }

    if (interacted.agreeTerms) {
      if (!state.agreeTerms) {
        validations.agreeTerms = new Utils.Validation(
          (
            <span>
              You need to agree with our
              <a href="https://www.cvikerar.com/privacy-policy">
                privacy policy
              </a>
            </span>
          ),
          "error"
        );
      } else {
        validations.agreeTerms = new Utils.Validation();
      }
    }

    let interactedWithAllRequired = this.required.every(r => {
      return this.interacted[r];
    });

    validations.invalid = Object.values(validations).some(validation => {
      return validation.invalid;
    });
    console.log("state during validation", state);
    return {
      validations: validations,
      invalid: validations.invalid || !interactedWithAllRequired
    };
  };

  resetForm = () => {
    this.setState({
      exppanded: null,
      projectName: "",
      description: "",
      email: "",
      agreeTerms: false,
      loading: false,
      showSuccess: false,
      lat: 30,
      lng: 0,
      rot: 0,
      validations: this.initValidations(),
      file: {},
      invalid: true,
      interacted: {}
    });
  };

  render() {
    const { classes } = this.props;
    console.log("classes props", this.props.classes);

    return (
      <div className="App">
        <div className={classes.root}>
          <div className={classes.wideColumn}>
            <form
              onSubmit={this.submit}
              id="publicUploadForm"
              name="publicUploadForm"
              noValidate
              onKeyPress={event => {
                if (event.which === 13 /* Enter */) {
                  event.preventDefault();
                }
              }}
            >
              <br />

              <TextField
                id="standard-name"
                label="Project name"
                required
                helperText={this.state.validations.projectName.message}
                className={classes.textField}
                value={this.state.projectName}
                error={this.state.validations.projectName.invalid}
                onChange={this.handleChange("projectName")}
                margin="normal"
                InputProps={{
                  required: true,
                  maxLength: 30
                }}
              />
              <br />
              <TextField
                id="email"
                label="Email"
                required
                helperText={this.state.validations.email.message}
                className={classes.textField}
                value={this.state.email}
                error={this.state.validations.email.invalid}
                onChange={this.handleChange("email")}
                margin="normal"
                InputProps={{
                  required: true,
                  maxLength: 30
                }}
              />
              <br />
              <TextField
                id="description"
                label="Description"
                required
                multiline
                helperText={this.state.validations.description.message}
                className={classes.textField}
                value={this.state.description}
                error={this.state.validations.description.invalid}
                onChange={this.handleChange("description")}
                margin="normal"
                InputProps={{
                  required: true,
                  maxLength: 30
                }}
              />

              <br />
              <FileInput
                inputRef={this.fileInput}
                onFileUpload={this.handleFileUpload}
                classes={classes}
                id="file-input"
                error={this.state.validations.file.invalid}
                helperText={this.state.validations.file.message}
                accept=".fbx,images/png"
              />
              <br />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.agreeTerms}
                    required

                    color="primary"
                    onChange={this.handleChecked("agreeTerms")}
                    value="agreeTerms"
                  />
                }
                label={
                  <span>
                    I agree with{" "}
                    <a
                      href="https://www.cvikerar.com/privacy-policy"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {" "}
                      privacy policy
                    </a>
                  </span>
                }
              />
            </form>

            <AdornedButton
              size="small"
              color="primary"
              variant="contained"
              className={classes.button}
              loading={this.state.loading}
              type="submit"
              disabled={this.state.invalid}
              form="publicUploadForm"
            >
              &nbsp;&nbsp;{this.state.loading ? "Uploading" : "Save"}
              &nbsp;&nbsp;
            </AdornedButton>

            <AlertDialog
              title="Sucess"
              handleClose={() => {
                this.handleModalSwitch(false);
              }}
              open={this.state.showSuccess}
              onClose={() => {
                this.handleModalSwitch(false);
              }}
              description="Your model has been successfully uploaded. We will contact you with further instructions."
            />
          </div>
        </div>
      </div>
    );
  }
}

PublicUpload.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(PublicUpload);
